<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        icon="el-icon-plus"
        @click="open('add')"
      >添加</el-button>
      <el-button
        type="danger"
        size="mini"
        icon="el-icon-delete"
        @click="removeQue"
      >删除</el-button>
      <el-button
        type="success"
        size="mini"
        icon="el-icon-refresh"
        @click="getList()"
      >刷新</el-button>
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-refresh"
        @click="getList()"
      >筛选</el-button>
      <el-button
        type="warning"
        size="mini"
        @click="resetEvent()"
      >重置</el-button>
    </div>
    <div class="head_search">
      <div class="item_warp">
        <label style="width: 64px">问卷名称</label>
        <el-input
          v-model="searchVal"
          placeholder="请输入问卷名称"
          style="width: 150px"
          size="mini"
          clearable
        />
      </div>
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="showtabelData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      style="width: 1131px"
      height="calc(100vh - 240px )"
      size="mini"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="queNo" label="编号（随机8位数）" width="150" />
      <el-table-column prop="queName" label="问卷名称" width="230" />
      <el-table-column prop="count" label="题目数" width="80" />
      <el-table-column prop="createdAt" label="创建时间" width="220">
        <template slot-scope="scope">
          {{
            $parseTime(new Date(scope.row.createdAt), "{y}-{m}-{d} {h}:{i}:{s}")
          }}
        </template>
      </el-table-column>
      <el-table-column label="修改日志" width="200">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-view"
            @click="checkLog(scope.row.id)"
          >查看</el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="open('edit', scope.row)"
          >修改</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="removeSingle(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNumber"
      :limit.sync="pageSize"
      @pagination="getList"
    />
    <!-- 添加弹窗 -->
    <el-dialog
      title="添加"
      :visible.sync="dialogVisible"
      width="900px"
      :close="handleClose"
      :close-on-click-modal="false"
      :center="true"
      style="height: 90vh; margin-top: 40px"
    >
      <el-form ref="form" :model="formData" label-width="220px" size="mini">
        <el-form-item label="问卷名称">
          <el-input
            v-model="formData.queName"
            placeholder="请输入文章标题"
            style="width: 300px"
            size="mini"
            clearable
          />
        </el-form-item>
        <el-form-item label="">
          <el-button
            type="primary"
            class="edit-button"
            size="mini"
            @click="questiontype(1)"
          >+单选</el-button>
          <el-button
            type="primary"
            class="edit-button"
            size="mini"
            @click="questiontype(2)"
          >+多选</el-button>
          <el-button
            type="primary"
            class="edit-button"
            size="mini"
            @click="questiontype(3)"
          >+五星评比</el-button>
          <el-button
            type="primary"
            class="edit-button"
            size="mini"
            @click="questiontype(4)"
          >+填空题</el-button>
        </el-form-item>
        <el-form-item
          v-for="(item, index) in questionList"
          :key="index"
          label=""
        >
          <div
            v-if="item.queType == 1 || item.queType == 2"
            class="questiontype"
          >
            <div class="questiontype_head">
              <div>{{ item.queType == 1 ? "单选题" : "多选题" }}</div>
              <div class="questiontype_head_right">
                <div
                  class="questiontype_head_right_card"
                  @click="exchange('below', index)"
                >
                  <i class="el-icon-arrow-down" />
                </div>
                <div
                  class="questiontype_head_right_card"
                  @click="exchange('up', index)"
                >
                  <i class="el-icon-arrow-up" />
                </div>
                <div
                  class="questiontype_head_right_card"
                  @click="deleteQuestion(index)"
                >
                  <i class="el-icon-delete" />
                </div>
              </div>
            </div>
            <div>
              <div>题目</div>
              <el-input
                v-model="item.title"
                style="width: 380px"
                size="mini"
                clearable
              />
            </div>
            <div>
              <div>选项</div>
              <el-input
                v-model="item.options"
                type="textarea"
                style="width: 380px"
                size="mini"
                clearable
              />
            </div>
            <div>
              <div>触发提醒选项</div>
              <el-input
                v-model="item.remind"
                type="textarea"
                style="width: 380px"
                size="mini"
                clearable
                :rows="5"
              />
            </div>
          </div>
          <div v-if="item.queType == 3" class="questiontype">
            <div class="questiontype_head">
              <div>五星评比</div>
              <div class="questiontype_head_right">
                <div
                  class="questiontype_head_right_card"
                  @click="exchange('below', index)"
                >
                  <i class="el-icon-arrow-down" />
                </div>
                <div
                  class="questiontype_head_right_card"
                  @click="exchange('up', index)"
                >
                  <i class="el-icon-arrow-up" />
                </div>
                <div
                  class="questiontype_head_right_card"
                  @click="deleteQuestion(index)"
                >
                  <i class="el-icon-delete" />
                </div>
              </div>
            </div>
            <div>
              <div>题目</div>
              <el-input
                v-model="item.title"
                style="width: 380px"
                size="mini"
                clearable
              />
            </div>
            <div>
              <div>低于几星答卷提醒</div>
              <el-input
                v-model="item.remind"
                style="width: 380px"
                size="mini"
                clearable
              />
            </div>
          </div>
          <div v-if="item.queType == 4" class="questiontype">
            <div class="questiontype_head">
              <div>填空题</div>
              <div class="questiontype_head_right">
                <div
                  class="questiontype_head_right_card"
                  @click="exchange('below', index)"
                >
                  <i class="el-icon-arrow-down" />
                </div>
                <div
                  class="questiontype_head_right_card"
                  @click="exchange('up', index)"
                >
                  <i class="el-icon-arrow-up" />
                </div>
                <div
                  class="questiontype_head_right_card"
                  @click="deleteQuestion(index)"
                >
                  <i class="el-icon-delete" />
                </div>
              </div>
            </div>
            <div>
              <div>题目</div>
              <el-input
                v-model="item.title"
                style="width: 380px"
                size="mini"
                clearable
              />
            </div>
            <div>
              <div>以下什么情况答卷提醒</div>
              <div>
                <el-radio
                  v-model="item.remind"
                  label="用户有填写"
                >用户有填写</el-radio>
                <el-radio
                  v-model="item.remind"
                  label="用户无填写"
                >用户无填写</el-radio>
                <el-radio v-model="item.remind" label="不提醒">不提醒</el-radio>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          style="margin-right: 10px"
          @click="dialogVisible = false"
        >取消</el-button>
        <el-popconfirm title="确定添加？" @onConfirm="isEdit ? edit() : add()">
          <el-button
            slot="reference"
            type="primary"
            class="edit-button"
          >保存</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>
    <!-- 修改日志弹窗 -->
    <el-dialog title="修改日志" :visible.sync="logDialogVisible">
      <el-table :data="logListData" border style="width: 100%">
        <el-table-column prop="updatedAt" label="日期" width="260">
          <template slot-scope="scope">
            {{
              $parseTime(
                new Date(scope.row.updatedAt),
                "{y}-{m}-{d} {h}:{i}:{s}"
              )
            }}
          </template>
        </el-table-column>
        <el-table-column prop="manager" label="管理员" />
        <el-table-column prop="operate" label="操作" />
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
// import uploadPic from '@/components/Upload/UploadPic' // 引入单图片上传组件
import Pagination from '@/components/Pagination' // 引入分页器
import {
  getQuestionList,
  updateQuestion,
  removeQuestion,
  addQuestion,
  logList,
  answerList,
  getSettingQue
} from '@/api/question.js'
export default {
  name: 'Order',
  components: { Pagination },
  data() {
    return {
      productName: '',
      searchVal: '',
      pageNumber: 1,
      pageSize: 20,
      loading: false,
      total: 0,
      showtabelData: [], // 表单数据
      multipleSelection: [], // 选中项
      dialogVisible: false, // 弹窗标识
      questionList: [],
      formData: {
        queNo: '',
        queName: '',
        count: 0
      },
      logListData: [],
      logDialogVisible: false,
      isEdit: false,
      queList: [],
      selectionQueList: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    filterMethod(e) {
      this.selectionQueList = this.showtabelData.filter((item) => {
        return item.queName.indexOf(e) > -1
      })
    },
    questiontype(type) {
      this.questionList.push({
        queType: type,
        title: '',
        options: '',
        remind: '',
        answer: ''
      })
      console.log(this.questionList)
    },
    // 删除题目
    deleteQuestion(index) {
      this.questionList.splice(index, 1)
    },
    // 筛选
    select() {
      this.pageNumber = 1
      this.getList()
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNum: this.pageNumber,
        pageSize: this.pageSize,
        queName: this.searchVal
      }
      this.loading = true
      getQuestionList(params)
        .then((res) => {
          this.showtabelData = res.rows
          this.selectionQueList = res.rows
          this.total = res.count
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    exchange(type, index) {
      if (type == 'below') {
        if (index + 1 != this.questionList.length) {
          this.upGo(this.questionList, index, index + 1)
        }
      } else {
        if (index != 0) {
          this.upGo(this.questionList, index, index - 1)
        }
      }
    },
    upGo(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0]
      console.log('fieldData', arr)
    },
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => item.id)
    },
    // 关闭添加弹窗
    handleClose() {
      this.initForm()
    },
    initForm() {
      this.formData = {
        queNo: '',
        queName: '',
        count: 0
      }
    },
    open(type, item) {
      this.isEdit = type === 'edit'
      this.questionList = []
      if (type == 'add') {
        this.initForm()
        this.dialogVisible = true
      } else if (type == 'edit') {
        this.formData = { ...this.formData, ...item }
        answerList({ parentId: item.id }).then((res) => {
          this.questionList = res
          this.dialogVisible = true
        })
      }
    },
    // 添加
    add() {
      if (!this.formData.queName) {
        return this.$message.warning('请输入问卷名称')
      }
      this.formData.count = this.questionList.length
      // 随机生成8位数编号
      this.formData.queNo = this.generateRandomNumber()
      const submitData = {
        question: this.formData,
        answer: this.questionList
      }
      this.questionList.forEach((item, index) => {
        item.sort = index
      })
      addQuestion(submitData)
        .then((res) => {
          this.$message.success('添加成功')
          this.getList()
          this.questionList = []
          this.dialogVisible = false
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    // 修改
    edit() {
      if (!this.formData.queName) {
        return this.$message.warning('请输入问卷名称')
      }
      this.formData.count = this.questionList.length
      const submitData = {
        question: this.formData,
        answer: this.questionList
      }
      this.questionList.forEach((item, index) => {
        item.sort = index
      })
      updateQuestion(submitData)
        .then((res) => {
          this.$message.success('修改成功')
          this.getList()
          this.dialogVisible = false
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    removeSingle(item) {
      this.multipleSelection = []
      this.multipleSelection.push(item.id)
      this.removeQue()
    },
    removeQue() {
      this.$confirm(
        '是否确认删除' + this.multipleSelection.length + '条数据?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          roundButton: true
        }
      ).then(() => {
        removeQuestion({ ids: this.multipleSelection }).then((res) => {
          this.$message.success('删除成功')
          this.getList()
        })
      })
    },
    // 生成一个随机的8位数字
    generateRandomNumber() {
      const min = 10000000 // 最小值为10000000
      const max = 99999999 // 最大值为99999999
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    checkLog(parentId) {
      if (!parentId) this.$message.warning('查看失败')
      this.logDialogVisible = true
      this.logListData = []
      logList({ parentId }).then((res) => {
        this.logListData = res
      })
    },
    resetEvent() {
      this.searchVal = ''
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
.head_search {
  display: flex;
  align-items: center;
  // justify-content: space-around;
  margin-bottom: 10px;
  width: 100%;
  .item_warp {
    display: flex;
    align-items: center;
    margin-right: 10px;
    .el-checkbox {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 20px;
    }
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #525252;
    }
  }
}
.role_warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
.isSyn {
  display: flex;
  align-items: center;
  justify-content: center;
}
.questiontype {
  width: 400px;
  min-height: 100px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
}
.questiontype_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.questiontype_head_right {
  display: flex;
  align-items: center;
}
.questiontype_head_right_card {
  margin-left: 10px;
}
::v-deep .el-form-item__content {
  display: block !important;
}
</style>
